import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TrashView = lazy(async () => {
  const m = await import("@/features/trash/components/trash-view");
  return { default: m.TrashView };
});

/**
 * ACTIVITY-CORE (L2) — papelera: restaurar productos/almacenes/ubicaciones/
 * operaciones. Sin "eliminar definitivamente": el rastro nunca se destruye.
 */
export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: () => (
    <Suspense fallback={null}>
      <TrashView />
    </Suspense>
  ),
});
